var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.images)?_c('div',{directives:[{name:"epi-edit",rawName:"v-epi-edit",value:(_vm.pagePropertyName),expression:"pagePropertyName"}]},[_c('Slider',{attrs:{"items":_vm.images}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }